import { defineComponent as _defineComponent } from 'vue'
import { provide } from 'vue'

import {
  useProductTour,
  productTourInjectionKey,
} from '@/composables/productTour'

interface ProductTourProps {
  /**
   * Unique key for localStorage persistence
   */
  tourKey: string
  /**
   * Whether to auto-start the tour if not completed
   */
  autoStart?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTour',
  props: {
    tourKey: null,
    autoStart: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { tourKey: string, autoStart: boolean };



const tourState = useProductTour(props.tourKey, props.autoStart)

// Provide tour state to child components
provide(productTourInjectionKey, tourState)

return { __sfc: true,props, tourState }
}

})